<template>
  <div class="flex flex-col lg:flex-row w-full h-full mx-auto py-4 lg:p-6">
    <div class="bg-white shadow-lg rounded-lg w-12/12 lg:w-2/6 mx-4 py-4 overflow-hidden mb-4 lg:mb-0">
      <div class="h-full overflow-auto px-4">
        <div class="flex items-center gap-1 justify-end pb-4 sticky top-0 bg-white relative z-10">
          <h1 class="flex items-center font-bold text-gray-900 px-2 py-2 gap-1 leading-tight tracking-wider">
            Lista de proyectos
            <span class="rounded-full px-4 py-1 bg-gray-200">
              {{ filteredProjects.length }}
            </span>
          </h1>
          <div class="flex-1"></div>
          <button
            class="border-2 rounded border-gray-700"
            @click="changeFormOrder"
            aria-label="Reordenar proyectos"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"/>
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </button>
        </div>
        <input
          type="text"
          v-model="search"
          placeholder="Búsqueda de proyectos"
          class="w-full appearance-none border rounded py-2 px-3 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
        />
      
        <div-selected-styled
          v-for="event in filteredProjects"
          :key="event.id"
          class="group flex items-center cursor-pointer my-1 py-2 px-5 text-left"
          :class="{ 'bg-selected': event.id === currentProject.id }"
          @click="selectProject(event)"
          :colorT="color_terciario"
        >
          <img
            :src="event.path_media_folder"
            class="h-12 w-12 object-cover"
            @error="loadDefaultImg"
          />
          <div class="flex flex-col flex-grow ml-2">
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ event.nombre }}</span
            >
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ event.fecha_creacion | moment("DD/MM/YYYY hh:mm A") }}</span
            >
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-sm group-hover:text-gray-700"
              >{{ event.institucion }}</span
            >
          </div>
        </div-selected-styled>
      </div>
    </div>

    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-12/12 lg:w-4/6 mx-4 py-4 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap">
          <div
            class="w-full pb-2 text-right"
          >
            <link-action-btn
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 border hover:border-transparent rounded cursor-pointer"
              @click="getLevantamientosByProject()"
              :colorT="color_terciario"
            >
              Ver galería
            </link-action-btn>
            <!-- <button
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Ver en mapa
            </button> -->
            <link-action-btn
              :href="replaceURLMapByUser()"
              target="_blank"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 border hover:border-transparent rounded"
              :colorT="color_terciario"
              >Ver en mapa</link-action-btn
            >
          </div>

          <!-- <div class="flex w-full">
            <div class="w-full">
              <div class="text-left font-bold text-sm text-gray-700">
                Ubicación:
              </div>
              <div class="flex">
                <div class="h-80 w-full">
                  <l-map
                    ref="map"
                    class="h-full w-full z-0"
                    :zoom="zoom"
                    :minZoom="4"
                    :center="center"
                    :options="{ zoomControl: true }"
                    @ready="onMapReady"
                  >
                    <l-tile-layer
                      :url="urlBasemap"
                      :attribution="attribution"
                    ></l-tile-layer>
                    <l-geo-json v-if="geojsonRouter" :geojson="geojsonRouter" />
                  </l-map>
                </div>
              </div>
            </div>
          </div> -->

          <!--seccion de informacion -->
          <div class="flex w-full">
            <div
              class="flex flex-col w-11/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >
              <p
                class="pb-1 pt-2 text-sm text-center font-bold tracking-widest"
              >
                Información del proyecto
              </p>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Nombre del proyecto:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{ currentProject.nombre }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Institución:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{ currentProject.institucion }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Líder de proyecto:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{ currentProject.lider }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Objetivo:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{ currentProject.objetivo }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold"
                    >Especificaciones multimedia:</span
                  >
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{ currentProject.especificaciones_multimedia }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Creado por:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{ currentProject.nombre_propietario }}
                  {{ currentProject.apellido_propietario }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Fecha de creación:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{
                    currentProject.fecha_creacion | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold"
                    >Fecha de aceptación / activación:</span
                  >
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{
                    currentProject.fecha_aceptacion
                      | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
                v-if="currentProject.id_curador !== null"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span
                    class="font-bold"
                    v-if="currentProject.status !== 'NO REVISADO'"
                    >Revisado por:</span
                  >
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs ml-2 mb-2 text-left"
                >
                  {{ currentProject.nombre_curador }}
                  {{ currentProject.apellido_curador }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
                v-if="currentProject.activo === false"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Fecha de desactivación:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{
                    currentProject.fecha_desactivacion
                      | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
                v-if="currentProject.activo === false"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Desactivado por:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                >
                  {{ currentProject.nombre_curador_desactivate }}
                  {{ currentProject.apellido_curador_desactivate }}
                </div>
              </div>

              <div
                v-if="currentProject.file_type == 'video/mp4'"
                class="flex justify-center py-2 w-full"
              >
                <video
                  :src="currentProject.path_media_folder"
                  width="640"
                  height="480"
                  controls
                  controlslist="nodownload"
                />
              </div>
              <div class="flex justify-center py-2 w-8/12 mx-auto">
                <v-lazy-image
                  v-if="currentProject.imagen !== null"
                  :src="currentProject.path_media_folder"
                />
              </div>
            </div>
          </div>
          <!--/seccion de informacion -->

          <!-- sección de ficha -->
          <div class="flex w-full">
            <div
              v-if="currentProject.ficha_proyecto"
              class="flex flex-col w-11/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >
              <p
                class="pb-1 pt-2 text-sm text-center font-bold tracking-widest"
              >
                Ficha de información
              </p>
              <br />
              <div
                v-for="one_question in currentQuestions"
                :key="one_question.id"
              >
                <div v-if="one_question.texto != null">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    ><span v-if="one_question.numero_pregunta">{{ one_question.numero_pregunta }}.-</span>
                    {{ one_question.texto }}
                    <template v-if="one_question.nota_para_registrante != ''">
                      ({{ one_question.nota_para_registrante }})
                    </template>
                  </label>

                  <div style="padding-left: 20px">
                    <div v-if="one_question.tipo === 'ABIERTA'">
                      <textarea-styled
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        value=""
                        disabled
                        :colorT="color_terciario"
                      />
                    </div>

                    <template v-if="one_question.tipo == 'SELECCION'">
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="radio"
                            name="question"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>

                      <div
                        v-if="one_question.otro === true"
                        class="flex items-left text-gray-700 font-bold"
                        style="align-items: baseline"
                      >
                        Otro: &nbsp; &nbsp;
                        <input-styled
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          placeholder="Escriba otra opción"
                          disabled
                          :colorT="color_terciario"
                        />
                      </div>
                    </template>

                    <template v-if="one_question.tipo == 'MULTISELECCION'">
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="checkbox"
                            name="question"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>

                      <div
                        v-if="one_question.otro === true"
                        class="flex items-left text-gray-700 font-bold"
                        style="align-items: baseline"
                      >
                        Otro: &nbsp; &nbsp;
                        <input-styled
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          placeholder="Escriba otra opción"
                          disabled
                          :colorT="color_terciario"
                        />
                      </div>
                    </template>

                    <template
                      v-if="one_question.tipo == 'SELECCION_CONDICIONAL'"
                    >
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="radio"
                            name="question"
                            :value="opt"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>

                      <template
                        v-for="(opt, index) in one_question.pregunta_condicion"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          ><span v-if="opt.numero_pregunta">{{ opt.numero_pregunta }}.-</span>
                          <span style="color: #909696" v-else-if="opt.id">({{ opt.id }})</span>
                          {{ opt.texto }}

                          <template v-if="opt.nota_para_registrante != ''">
                            ({{ opt.nota_para_registrante }})
                          </template>
                        </label>

                        <template v-if="opt.tipo == 'SELECCION'">
                          <!-- pregunta condicional de selecion -->
                          <template v-for="(opt1, index) in opt.opciones">
                            <div
                              class="flex items-center text-gray-700 font-bold"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="radio"
                                name="question"
                                :value="opt"
                                disabled
                              />
                              <span>
                                {{ opt1 }}
                              </span>
                            </div>
                          </template>
                        </template>

                        <div v-if="opt.tipo === 'ABIERTA'">
                          <!-- pregunta condicional abierta -->
                          <textarea-styled
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                            :colorT="color_terciario"
                          />
                        </div>

                        <template v-if="opt.tipo == 'CAMPOS' || opt.tipo == 'GRUPO_REPETIBLE' || opt.tipo == 'MINI_FORMULARIO'">
                          <!-- pregunta condicional de campos -->
                          <template v-for="(opt1, index) in opt.campos">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ opt1.texto }}</label
                              >
                              <input-styled
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                                :colorT="color_terciario"
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>

                    <template v-if="one_question.tipo == 'OPCION_SEGUIMIENTO'">
                      <div v-for="(concepto, cIdx) in one_question.conceptos" :key="'concepto_' + cIdx" class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2 text-left">{{ concepto }}</label>
                        <div class="flex items-center gap-4 text-gray-700 font-bold mb-2">
                          <div class="flex items-center gap-2">
                            <input type="radio" disabled />
                            <span>{{ one_question.opcion_si }}</span>
                          </div>
                          <div class="flex items-center gap-2">
                            <input type="radio" disabled />
                            <span>{{ one_question.opcion_no }}</span>
                          </div>
                        </div>
                      </div>
                    </template>

                    <template v-if="one_question.tipo == 'CAMPOS' || one_question.tipo == 'GRUPO_REPETIBLE' || one_question.tipo == 'MINI_FORMULARIO'">
                      <template v-for="(opt, index) in one_question.campos">
                        <div class="flex w-full items-center justify-center">
                          <label
                            class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                            >{{ opt.texto }}</label
                          >
                          <input-styled
                            class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                            :colorT="color_terciario"
                          />
                        </div>
                      </template>
                    </template>

                    <template v-if="one_question.tipo == 'MATRIZ'">
                        <div class="overflow-x-auto mb-3 pl-4">
                          <table class="w-full text-left border-collapse">
                            <thead>
                              <tr>
                                <th class="border-b-2 p-2"></th>
                                <th
                                  v-for="(col, colIdx) in (one_question.columnas || [])"
                                  :key="'col_' + colIdx"
                                  class="border-b-2 p-2 text-sm text-gray-700 font-bold text-center"
                                >
                                  {{ col }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(fila, idx) in (one_question.filas || [])"
                                :key="'fila_' + idx"
                              >
                                <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                  {{ fila }}
                                </td>
                                <td
                                  v-for="(col, colIdx) in (one_question.columnas || [])"
                                  :key="'td_' + idx + '_' + colIdx"
                                  class="border-b p-2 text-center"
                                >
                                  <input type="radio" disabled class="leading-tight" />
                                </td>
                              </tr>
                              <tr v-if="one_question.otro">
                                <td class="border-b p-2 text-sm text-gray-500 italic">
                                  Otro (opcional)
                                </td>
                                <td
                                  v-for="(col, colIdx) in (one_question.columnas || [])"
                                  :key="'td_otro_' + colIdx"
                                  class="border-b p-2 text-center"
                                >
                                  <input type="radio" disabled class="leading-tight" />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </template>

                    <template v-if="one_question.hasOwnProperty('subpregunta')">
                      <!-- Subpreguntas -->
                      <template
                        v-for="(opt, index) in one_question.subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          ><span v-if="opt.numero_pregunta">{{ opt.numero_pregunta }}.-</span>
                          {{ opt.texto }}
                          <template v-if="opt.nota_para_registrante != ''">
                            ({{ opt.nota_para_registrante }})
                          </template>
                        </label>
                        <div v-if="opt.tipo === 'ABIERTA'">
                          <!-- Subpregunta abierta -->
                          <textarea-styled
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                            :colorT="color_terciario"
                          />
                        </div>

                        <template v-if="opt.tipo == 'SELECCION'">
                          <!-- Subpregunta de selección -->
                          <template v-for="(opt, index) in opt.opciones">
                            <div
                              class="flex items-center text-gray-700 font-bold"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="radio"
                                name="question"
                                :value="opt"
                                disabled
                              />
                              <span>
                                {{ opt }}
                              </span>
                            </div>
                          </template>

                          <div
                            v-if="opt.otro === true"
                            class="flex items-left text-gray-700 font-bold"
                            style="align-items: baseline"
                          >
                            Otro: &nbsp; &nbsp;
                            <input-styled
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              value=""
                              placeholder="Escriba otra opción"
                              disabled
                              :colorT="color_terciario"
                            />
                          </div>
                        </template>

                        <template v-if="opt.tipo == 'CAMPOS' || opt.tipo == 'GRUPO_REPETIBLE' || opt.tipo == 'MINI_FORMULARIO'">
                          <!-- Subpregunta de campos -->
                          <template v-for="(opt, index) in opt.campos">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ opt.texto }}</label
                              >
                              <input-styled
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                                :colorT="color_terciario"
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /sección de ficha -->
        </div>
      </div>
    </div>

    <!-- sección de galería -->
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-10/12 max-h-full bg-white shadow-lg rounded-lg overflow-auto px-4"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="flex w-full justify-end mb-4">
            <button
              aria-label="close"
              class="text-xl text-gray-500"
              @click.prevent="close"
            >
              ×
            </button>
          </div>
        </div>

        <gallery-grid
          :multimedia="listGalleryMultimedia"
          :colorP="color_principal"
          :colorS="color_secundario"
          :colorT="color_terciario"
        ></gallery-grid>

        <div class="flex w-full sticky bottom-0 justify-end pb-5 mt-4 bg-white">
          <btn-modal
            class="ml-2 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
            @click="close()"
            :colorT="color_terciario"
          >
            Cerrar
          </btn-modal>
        </div>
      </div>
    </div>
    <!-- /sección de galería -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import GalleryGrid from "./GalleryGrid";

import { styled } from "@egoist/vue-emotion";

// Nombre de días...
const weekday = new Array(7);
weekday[0] = "Dom";
weekday[1] = "Lun";
weekday[2] = "Mar";
weekday[3] = "Mie";
weekday[4] = "Jue";
weekday[5] = "Vie";
weekday[6] = "Sáb";

// Nombres de meses...
const month = new Array();
month[0] = "Ene";
month[1] = "Feb";
month[2] = "Mar";
month[3] = "Abr";
month[4] = "May";
month[5] = "Jun";
month[6] = "Jul";
month[7] = "Ago";
month[8] = "Sep";
month[9] = "Oct";
month[10] = "Nov";
month[11] = "Dic";

const DivSelectedStyled = styled("div")`
  &.bg-selected {
    background-color: ${(props) => props.colorT};
  }
  &:hover {
    background-color: #d1d5db;
  }
`;

const LinkActionBtn = styled("a")`
  color: ${(props) => props.colorT};
  border-color: ${(props) => props.colorT};
  &:hover {
    background-color: ${(props) => props.colorT};
  }
`;

const BtnModal = styled("button")`
  background-color: ${(props) => props.colorT};
`;

const TextareaStyled = styled("textarea")`
  border-color: ${(props) => props.colorT};
  resize: none;
`;

const InputStyled = styled("input")`
  border-color: ${(props) => props.colorT};
`;

export default {
  name: "ProjectExplorer",
  data: function () {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      category: window.atob(localStorage.getItem("category")),
      email: localStorage.getItem("email"),
      id_usuario: localStorage.getItem("user_id"),
      projects: [],
      search: "",
      formOrder: "upward",
      currentProject: {
        imagen: null,
        path_media_folder: "",
      },
      currentQuestions: [],
      listGalleryMultimedia: [],
      showing: false,
      color_principal: "",
      color_secundario: "",
      color_terciario: "",
    };
  },
  components: {
    GalleryGrid,
    DivSelectedStyled,
    LinkActionBtn,
    BtnModal,
    TextareaStyled,
    InputStyled,
  },
  mounted() {
    this.fetchProjects();
  },
  methods: {
    fetchProjects() {
      this.$root.$emit("showLoading");
      axios
        .post(
          "apidev/projects/getProjectsAll",
          {
            id_usuario: localStorage.getItem("user_id"),
          },
          this.config
        )
        .then((response) => {
          this.projects = response.data.proyectos;
          if (this.filteredProjects.length > 0) {
            this.selectProject(this.filteredProjects[0]);
          }

          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.$root.$emit("hideLoading");
          this.catchError(error);
          this.showingError = false;
        });
    },
    selectProject(event) {
      this.$root.$emit("showLoading");
      this.currentProject = event;

      axios
        .post(
          "../apidev/projects/getFichaRespuestasJson",
          {
            id_project: this.currentProject.id,
          },
          this.config
        )
        .then((response) => {
          this.currentQuestions = response.data.answers;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => this.catchError(error));
    },
    changeFormOrder() {
      this.formOrder = this.formOrder === "upward" ? "downward" : "upward";
    },
    loadDefaultImg(event) {
      event.target.src = require("@/assets/default-image-sm.jpg");
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },
    getLevantamientosByProject() {
      this.$root.$emit("showLoading");

      axios
        .post(
          "apidev/levantamientos/getLevantamientosByProject",
          {
            id_project: this.currentProject.id,
            id_usuario: this.id_usuario,
          },
          this.config
        )
        .then((response) => {
          let listaLevantamientos = response.data.levantamientos;

          this.listGalleryMultimedia = [];
          listaLevantamientos.forEach((levantamiento) => {
            if (levantamiento.media_array !== null) {
              let multimediaArray = JSON.parse(levantamiento.media_array);
              multimediaArray.forEach((multimedia) => {
                //if (multimediaArray.length > 0) {
                multimedia.usuario_id = levantamiento.usuario_id;
                multimedia.nombre = levantamiento.nombre;
                multimedia.nombre_usuario = levantamiento.nombre_usuario;
                multimedia.apellido_usuario = levantamiento.apellido_usuario;
                let TDate = new Date(levantamiento.fecha_levantamiento);
                TDate =
                  weekday[TDate.getDay()] +
                  " " +
                  TDate.getDate() +
                  " de " +
                  month[TDate.getMonth()] +
                  " de " +
                  TDate.getFullYear();
                multimedia.TDate = TDate;
                multimedia.id = levantamiento.id;
                multimedia.latitud = levantamiento.latitud;
                multimedia.longitud = levantamiento.longitud;
                this.listGalleryMultimedia.push(multimedia);
                //}
              });
            }
          });

          this.showing = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => this.catchError(error));
    },
    close() {
      this.showing = false;
    },
    replaceURLMapByUser(register) {
      return `../../levProyecto/${this.currentProject.id}`;
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then((response) => {
          let conf = response.data.config;
          /* this.url_image = conf.url_image; */
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
  },
  computed: {
    filteredProjects() {
      return this.projects
        .filter((elem) => {
          let date = moment(elem.fecha_creacion).format("DD/MM/YYYY");
          let new_string_search = `${date.toLowerCase()} ${elem.id.toString()} ${elem.nombre.toLowerCase()}`;

          return (
            new_string_search.includes(this.search.toLowerCase()) &&
            elem.status == "APROBADO"
          );
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            return new Date(a.fecha_creacion) - new Date(b.fecha_creacion);
          } else {
            return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
          }
        });
    },
  },
  beforeMount() {
    this.fetchConfiguration();
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
